//Return number of days between two dates
export const diffDays = (firstDate, secondDate) => Math.ceil(Math.abs(firstDate - secondDate) / (1000 * 60 * 60 * 24));